// import AdditionnalMetadata from "../data/AdditionnalMetadata";
import AdditionnalMetadata from "../Model/AdditionnalMetadata";
import Navette from "../Model/Navette";
import User from "../Model/User";
import Document from "../Model/Document";
import Loc from "../../Loc/Loc";

//const webApiUsersUrl = "https://portal.fnordon.fivesgroup.com/portail_APIV2/users/";
const  webApiUrl = process.env.REACT_APP_API_URL;
const baseUrlUsers = `${process.env.REACT_APP_API_URL}/users`;
export class WebApi {
    public Authenticate = (_username: string, _password: string): Promise<User> => {
        return fetch(webApiUrl + "/users/" + "authenticate",
            { 
                method: 'post', 
                body: JSON.stringify({ Username: _username, Password: _password }),
                headers: new Headers({
                    'Content-type': 'application/json'
                })
            })
            .then(res => res.json())
            .then((result) => {
                if (result.username === undefined) {
                    return Promise.reject("Unknown user");
                }
                return Promise.resolve(result);
            })
            .catch((error) => {
                return Promise.reject(error);
            })
    }

    public UpdatePassword = (_username: string, _password: string, _id: number, _jwtToken: string): Promise<User> => {
        return fetch(baseUrlUsers + "/update/" + _id,
            {
                method: 'put',
                body: JSON.stringify({ Username: _username, Password: _password }),
                headers: new Headers({
                    'Content-type': 'application/json',
                    'Authorization': 'Bearer ' + _jwtToken
                })
            })
            .then(res => res.json())
            .then((result) => {
                if (result.username === undefined) {
                    return Promise.reject("Unknown user");
                }
                return Promise.resolve(result);
            })
            .catch((error) => {
                return Promise.reject(error);
            })
    }

    public isUserConnected = (_token: string): Promise<Boolean> => {
        return fetch(baseUrlUsers + "/secretActionForUser",
        {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + _token
            })
        })
        .then((res) => {
            if (res.status === 200) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        })
        .catch(() => {
            return Promise.resolve(false);
        })
    }

    public Download = (_token: string, type: string, id: number, name: string): Promise<string> => {
        // _token = "token invalide";
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let headers = new Headers();
        let extension: string = "";
        headers.append('Authorization', 'Bearer ' + _token);
    
        return fetch(webApiUrl + "/"+ type + "/download/" + id, { headers })
        .then(response => {
            extension = response.headers.get("Content-type")?.replace("application/", ".") || "";
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.blob();
        })
        .then(blobby => {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = name + extension;
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
            return Promise.resolve(dd + '/' + mm + '/' + yyyy);
        })
        .catch(error => {return Promise.reject(error)})
    }

    public updateNav = (_token: string, status: string, comment: string, id: number, file: any): Promise<Navette> => {

        const formData = new FormData();

        formData.append('status', status);
        formData.append('comment', comment);
        formData.append('id', id.toString());
        formData.append('file', file);
        formData.append('encType', "multipart/form-data");

        return fetch(`${process.env.REACT_APP_API_URL}/Navettes/updateNav`,
        {
            method: 'post',
            body: formData,
            headers: new Headers({
                'Authorization': 'Bearer ' + _token,
                // 'Content-type': 'multipart/form-data'
            })
        })
        .then(response => {
            if (!response.ok) {
                if ([401, 403].includes(response.status)) {
                    return Promise.reject({message: "Unauthorized"});
                }
                return Promise.reject({message: Loc.trad().WebApiErrorBadRequest});
            }
            return response.json();
        })
        .then(response => { return Promise.resolve(response) })
        .catch(error => { return Promise.reject(error) })
    }

    public uploadDocument = (_token: string, name: string, additionnalMetas: AdditionnalMetadata[], file: File[], update: boolean, docId?: number): Promise<Document> => {
        let docRequest: string = update ? "modifyDocument" : "uploadDocument";
        const formData = new FormData();

        formData.append('name', name);
        for (var i = 0; i < additionnalMetas.length; i++) {
            formData.append('additionnalMetas[' + i + '].Name', additionnalMetas[i].name);
            formData.append('additionnalMetas[' + i + '].Property', additionnalMetas[i].alias);
            formData.append('additionnalMetas[' + i + '].Value', additionnalMetas[i].value);
        }
        for (var j = 0; j < file.length; j++) {
            formData.append('file', file[j]);
        }
        if (update) {
            formData.append('Id', docId!.toString());
        }
        formData.append('encType', "multipart/form-data");

        return fetch(`${process.env.REACT_APP_API_URL}/Document/` + docRequest,
        {
            method: 'post',
            body: formData,
            headers: new Headers({
                'Authorization': 'Bearer ' + _token,
                // 'Content-type': 'multipart/form-data'
            })
        })
        .then(response => {
            if (!response.ok) {
                // return Promise.reject({message: response.statusText})
                if ([401, 403].includes(response.status)) {
                    return Promise.reject({message: Loc.trad().WebApiErrorRights});
                }
                return Promise.reject({message: Loc.trad().WebApiErrorInvalid});
            }
            return Promise.resolve(response.json());
        })
        .catch(error => { return Promise.reject(error) })
    }

    public publicDownloadCollections = (hash: string, email: string, tmpCode: string): Promise<void> => {
        let name: string | null;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        // let extension: string = "";
    
        return fetch(webApiUrl + `/Collections/download/` + hash + '/' + email + '/' + tmpCode)
        .then(response => {
            name = response.headers.get("content-disposition");
            console.log(name);
            if (name) {
                console.log(name);
                name = name.split(";")[1].split("filename=")[1];
            }
            console.log(name);
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.blob();
        })
        .then(blobby => {
            // console.log(blobby);
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = name ? name : "Collection";
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
            return Promise.resolve();
        })
        .catch(error => {return Promise.reject(error)})
    }
}